// Inserts Cloudinary delivery transformations (auto format, auto quality,
// and an optional width cap) into a Cloudinary URL so the browser downloads
// a right-sized, well-compressed image instead of the original upload.
// Safe no-op for any URL that isn't a Cloudinary URL (legacy seed images,
// local /api/files/ uploads) -- never rewrites those.
export function cldUrl(url, { w } = {}) {
  if (!url || typeof url !== "string") return url;
  const marker = "/upload/";
  const idx = url.indexOf(marker);
  if (!url.includes("res.cloudinary.com") || idx === -1) return url;
  const transforms = ["f_auto", "q_auto", w ? `w_${w}` : null].filter(Boolean).join(",");
  return url.slice(0, idx + marker.length) + transforms + "/" + url.slice(idx + marker.length);
}
